<template>
	<div v-if="items?.length" class="flex flex-wrap relative flex-1">
		<div
			class="grid grid-cols-2 lg:grid-cols-4 gap-4 w-full transition-opacity"
			:class="!isLoaded ? 'opacity-50' : ''"
		>
			<template v-for="(item, index) in items" :key="item.id">
				<template v-if="item.type === 'product'">
					<template v-if="index < 2">
						<ProductCard
							:product="item.data"
							picture-size="h-auto max-w-full"
							:picture-aspect-ratio="pictureAspectRatio"
							class="min-h-[300px]"
							:lazy-loading="false"
							:variants="item.variants"
							:all-parametrics="allParametrics"
							:show-variants="showVariants"
						/>
					</template>
					<template v-else>
						<LazyLoadWrapper>
							<ProductCard
								:product="item.data"
								picture-size="h-auto max-w-full"
								:picture-aspect-ratio="pictureAspectRatio"
								class="min-h-[300px]"
								:lazy-loading="true"
								:variants="item.variants"
								:all-parametrics="allParametrics"
								:show-variants="showVariants"
							/>
						</LazyLoadWrapper>
					</template>
				</template>
				<template v-else-if="item.type === 'advertisement'">
					<StoryblokComponent
						:blok="item.data"
						:is-category="item.data.component === 'Hero' ? true : null"
						:class="item.isFullWidth ? 'col-span-2' : ''"
					/>
				</template>
			</template>
		</div>
		<CategoryPagination
			:current-page="currentPage"
			:item-count="itemCount"
			:page-size="pageSize"
		/>
	</div>
	<div
		v-else
		class="flex flex-col relative flex-1 items-center justify-center min-h-[400px]"
	>
		<span class="p-4"> {{ $t("no_more_products") }}</span>
		<NuxtLink to="/" class="button-primary">
			{{ $t("Go back home") }}
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
import LazyLoadWrapper from "~/components/LazyLoadWrapper.vue";
import ProductCard from "~/templates/breadandboxers/components/Product/ProductCard.vue";
import type { CombinedItem } from "~/types/components/category";
import type { ParametricListValue } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

interface Props {
	items: CombinedItem[];
	pageSize: string;
	pictureAspectRatio: string | undefined;
	currentPage: number;
	isLoaded: boolean | undefined;
	categoryName?: string;
	itemCount: number;
	allParametrics?: ParametricListValue[];
	showVariants?: boolean;
}

const {
	items,
	pageSize,
	pictureAspectRatio,
	currentPage,
	isLoaded,
	itemCount,
	allParametrics,
	showVariants = false
} = defineProps<Props>();
</script>
